<template>
	<div class="traveler">
		<back-to></back-to>
		<!-- 提交表单 -->
		<section class="travelerForm" v-for="(title, sort) in listTitle" :key="sort"
			v-if="list[sort]!== undefined && list[sort]!== null && list[sort].length > 0">
			<div class="title">{{title}}</div>
			<div class="travelerForm-van">
				<section v-for="(item, index) in list[sort]" :key="index" class="travelerForm-vans">
					<!-- 时间选择器 -->
					<van-field v-if="item.inputType == 'date'" readonly clickable name="date" v-model="item.tagValue"
						:label="item.tagName" :required="item.isMust" :placeholder="'请选择'+item.tagName"
						:rules="[{ required: item.isMust?true:false}]"
						@click="datePicker = true,selectIndex=index,sortIndex=sort" />
					<van-popup v-model="datePicker" position="bottom">
						<van-datetime-picker type="date" title="选择年月日" @confirm="onConfirmDate"
							@cancel="datePicker = false" :min-date="minDate" :max-date="maxDate"
							v-model="currentDate" />
					</van-popup>
					<!-- 选择器 -->
					<van-field v-if="item.inputType == 'select'" readonly clickable name="picker"
						v-model="item.tagValue" :label="item.tagName" :required="item.isMust"
						:placeholder="'请选择'+item.tagName" :rules="[{ required: item.isMust?true:false}]"
						@click="showPicker = true,columns = item.mag.select,selectIndex=index,sortIndex=sort" />
					<van-popup v-model="showPicker" position="bottom">
						<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
					</van-popup>

					<!-- 文本框 -->
					<van-field v-if="item.inputType == 'text' || item.inputType == 'number'" v-model="item.tagValue"
						:required="item.isMust" :label="item.tagName" :placeholder="'请填写'+item.tagName"
						:rules="[{ required: item.isMust?true:false}]" @input="inputBtn(sort,index,item.tagValue)" />
				</section>

			</div>
		</section>
		<div class="travelerForm-b" @click="onSubmit">
			保存
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		validatePhoneNumber,
		formatTime
	} from '@/config/util'
	import BackTo from "@/components/BackTo";
	import {
		Dialog
	} from 'vant'
	export default {
		name: 'traveler',
		components: {
			BackTo
		},
		data() {
			return {
				listArray: [],
				list: [],
				name: '',
				obj: {},
				listTitle: ['基本信息', '证件信息', '监护人信息', '其他信息'],
				columns: [],
				showPicker: false,
				selectIndex: "",
				sortIndex: "",
				datePicker: false,
				minDate: new Date(new Date().getFullYear() - 20, 0, 1),
				maxDate: new Date(new Date().getFullYear() + 5, 11, 31),
				currentDate: new Date()
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			this.obj = this.$route.query.object ? JSON.parse(this.$route.query.object) : ""
		},
		mounted() {
			this.getList()
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		},
		methods: {
			onConfirm(value) {
				let data = this.list
				data[this.sortIndex][this.selectIndex].tagValue = value
				this.list = data
				this.showPicker = false;
			},
			onConfirmDate(value) {
				let data = this.list
				data[this.sortIndex][this.selectIndex].tagValue = formatTime(value)
				this.list = data
				this.datePicker = false;
			},
			onSubmit() {
				if (this.$route.query.type == 0) {
					this.add()
				}
				if (this.$route.query.type == 1 && this.obj.templatTag.length == this.listArray.length) {
					this.edit()
				}
			},
			inputBtn(sort, e, value) {
				let data = this.list
				data[sort][e].tagValue = value
				this.list = data
			},
			edit() {
				var arr = []
				var list = [...this.list[0], ...this.list[1], ...this.list[2], ...this.list[3]]
				for (let i = 0; i < list.length; i++) {
					if (list[i].isMust == true && list[i].tagValue == '') {
						Dialog.alert({
							message: '请填写' + list[i].tagAliasName
						})
						return
					}
					const obj = {}
					obj.id = this.obj.templatTag[i].id
					obj.order_UserTemplateTagId = list[i].order_UserTemplateTagId
					obj.tagValue = list[i].tagValue.toString().replace(/\s+/g, "");
					arr.push(obj)
				}
				this.$_postNew(
					this.$severOrder + '/Order_UserTemplateBase/CreateOrUpdate', {
						"order_UserTemplateBase": {
							'id': this.obj.id,
							"userId": this.userInfo.userId, //用户ID						
							"order_UserTemplate": arr
						}
					}
				).then(res => {
					if (res.result.isSuccess) {
						Dialog.alert({
							message: '保存成功',
						}).then(() => {
							this.$router.back(-1)
						});

					} else {
						Dialog.alert({
							message: res.result.msg,
						})
					}
				})
			},
			add() {
				var arr = []
				var list = [...this.list[0], ...this.list[1], ...this.list[2], ...this.list[3]]
				for (let i = 0; i < list.length; i++) {
					if (list[i].isMust == true && list[i].tagValue == '') {
						Dialog.alert({
							message: '请填写' + list[i].tagAliasName
						})
						return
					}
					const obj = {}
					obj.order_UserTemplateTagId = list[i].order_UserTemplateTagId
					obj.tagValue = list[i].tagValue.toString().replace(/\s+/g, "");
					arr.push(obj)
				}
				this.$_postNew(
					this.$severOrder + '/Order_UserTemplateBase/CreateOrUpdate', {
						"order_UserTemplateBase": {
							"userId": this.userInfo.userId, //用户ID						
							"order_UserTemplate": arr
						}
					}
				).then(res => {
					if (res.result.isSuccess) {
						Dialog.alert({
							message: '保存成功',
						}).then(() => {
							this.$router.back(-1)
						});

					} else {
						Dialog.alert({
							message: res.result.msg,
						})
					}
				})
			},
			getList() {
				this.$_getNew(
					this.$severOrder + '/Order_UserTemplate/GetTemplateAsync?id=' + this.$route.query
					.templateId, {}
				).then(res => {
					let newArray = [];
					let newArray1 = [];
					let newArray2 = [];
					let newArray3 = [];
					res.result.forEach((e, index) => {
						if (e.mag != 'string') {
							e.mag = e.mag.replace(/\ufeff/g, ""); //重点
							e.mag = JSON.parse(e.mag);
						}
						if (this.$route.query.type == 1 && this.obj.templatTag.length == res.result
							.length) {
							e.tagValue = this.obj.templatTag[index].tagValue
							if (e.inputType == 'select') {
								e.mag.checked = e.mag.select.findIndex(item => item == this.obj
									.templatTag[index].tagValue)
							}
						} else {
							if (e.inputType == 'select') {
								e.tagValue = e.mag.select[e.mag.checked]
							} else {
								e.tagValue = ''
							}
						}
						if (e.sort <= 10) {
							newArray.push(e);
						} else if (e.sort > 10 && e.sort <= 20) {
							newArray1.push(e);
						} else if (e.sort > 20 && e.sort <= 30) {
							newArray2.push(e);
						} else if (e.sort > 30) {
							newArray3.push(e);
						}
					});
					this.list = [newArray, newArray1, newArray2, newArray3]
					this.listArray = res.result
				})
			},

		}
	}
</script>

<style>
	.travelerForm {
		width: 100%;
		/* padding: 20px 30px;
		box-sizing: border-box; */
	}

	.title {
		font-size: 26px;
		color: #999999;
		padding: 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.travelerForm-van {
		/* border-radius: 25px; */
		padding: 10px;
		box-sizing: border-box;
		width: 100%;
		background-color: #fff;
	}

	.travelerForm-vans {
		border-bottom: 1px solid #f7f7f7;
	}

	.travelerForm-vans:last-child {
		border: 0;
	}

	.travelerForm-b {
		width: 710px;
		margin: 40px auto;
		height: 90px;
		line-height: 90px;
		text-align: center;
		background: #F9902F;
		box-shadow: 0px 3px 10px 1px rgba(236, 224, 215, 0.6784);
		font-size: 36px;
		color: #fff;
		border-radius: 40px;
	}

	.travelerForm-van .van-overlay {
		background-color: rgba(0, 0, 0, .1);
	}
</style>